export default __webpack_public_path__ + "static/media/4.9fee7f77.svg";